import UserQuery from '../../api/account/user/query';
import UserScenario from '../../api/account/user/scenario';
import AuthClient from '@/utils/auth';

const createInitialState = () => ({
  isLoggedIn: false,
  username: '',
  email: '',
  userId: '',
  isSuperuser: false,
  profile: {},
  company: {},
  supportEmail: '',
  isDispSupportTel: true,
  isDispPoweredLabel: false,
  isUserGroupUsable: false,
  isProfessionalPlan: false,
  isVersionMngUsable: false,
  isProfessionalPlanTrial: false,
  brandKey: ''
});

export const auth = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: createInitialState(),
  getters: {
    isLoggedIn: (state) => state.isLoggedIn,
    getUserName: (state) => state.username,
    getEmail: (state) => state.email,
    getUserId: (state) => state.userId,
    isSuperuser: (state) => state.isSuperuser,
    getProfile: (state) => state.profile,
    getCompany: (state) => state.company,
    isProfessionalPlan: (state) => state.isProfessionalPlan,
    isProfessionalPlanTrial: (state) => state.isProfessionalPlanTrial,
    isUserGroupUsable: (state) => state.isUserGroupUsable,
    isVersionMngUsable: (state) => state.isVersionMngUsable,
    getSupportEmail: (state) => state.supportEmail,
    isDispSupportTel: (state) => state.isDispSupportTel
  },
  mutations: {
    loggedIn(state, refresh) {
      state.isLoggedIn = true;
      try {
        window.sessionStorage.removeItem('loggingOutAt');
      } catch (e) {
        // ignore
      }
    },
    loggedOut(state) {
      Object.assign(state, createInitialState());
    },
    setUserInfo(state, userInfo) {
      state.userId = userInfo.id;
      state.username = userInfo.username;
      state.email = userInfo.email;
      state.profile = userInfo.profile;
      state.company = userInfo.profile.company;
      state.isSuperuser = userInfo.isSuperuser;
      state.supportEmail = userInfo.profile.supportEmail;
      state.isDispSupportTel = userInfo.profile.isDispSupportTel;
      state.supportEmail = userInfo.profile.supportEmail;
      state.isUserGroupUsable = userInfo.profile.company.companyContracts.userGroup;
      state.isProfessionalPlan = userInfo.profile.company.companyContracts.professionalPlan;
      state.isProfessionalPlanTrial = userInfo.profile.company.companyContracts.professionalPlanTrial;
      state.isVersionMngUsable = userInfo.profile.company.companyContracts.versionManagement;
      state.brandKey = 'lecheck';
      state.isDispPoweredLabel = false;
      localStorage.setItem('brandKey', 'lecheck');
    }
  },
  actions: {
    async redirectCallback({ commit }) {
      try {
        // callback 開始時点で logout フラグが残っている可能性があるためクリア
        try {
          window.sessionStorage.removeItem('loggingOutAt');
        } catch (e) {
          // ignore
        }
        await AuthClient.handleRedirectCallback();
        const userInfo = await UserScenario.verifyUser();
        commit('loggedIn');
        commit('setUserInfo', userInfo.data.data);
        return userInfo.data.data;
      } catch (err) {
        // console.error('redirectCallback エラー', err);
        commit('loggedOut');
        // 呼び出し元（AuthCallback.vue）の catch に流してログイン画面へ遷移させる
        throw err;
      }
    },
    async logout({ commit }) {
      // ログアウトは「どんな失敗があっても画面上はログアウト」に倒す。
      // ここで例外が外に漏れると、呼び出し側の未await dispatch で Uncaught (in promise) になり得るため、reject させない。
      try {
        // ログアウト開始直後は token 取得/API が失敗しやすく、
        // interceptor の「セッションタイムアウト」警告が出ないようフラグを立てる（短時間のみ有効）。
        try {
          window.sessionStorage.setItem('loggingOutAt', String(Date.now()));
        } catch (e) {
          // ignore
        }

        try {
          await AuthClient.logout();
        } catch (err) {
          // ログアウト自体が失敗しても、画面上はログアウト状態にする
          console.error('logout error', err);
        }
      } catch (err) {
        console.error('logout unexpected error', err);
      } finally {
        commit('loggedOut');
      }
    },
    updateUserInfo({ commit, dispatch }) {
      UserQuery.getUserDetail().then((res) => {
        const data = res.data.data;
        commit('setUserInfo', data);
      });
    }
  }
};
